import { Input } from '@/app/components/ui/input';
import { useRenameFile } from '../../../_hooks/use-rename-file';
import type { FileItem, FolderTreeNode } from '../../../types';
import type { RenameState, RenameStateData } from '../types';

// 自定义节点组件
interface TreeNodeLabelProps {
  node: FolderTreeNode;
  onRenameStateChange: (state: RenameState, data: RenameStateData) => void;
  onFilesUpdate?: (updater: (files: FileItem[]) => FileItem[]) => void;
}

export const TreeNodeLabel: React.FC<TreeNodeLabelProps> = ({ node, onRenameStateChange, onFilesUpdate }) => {
  const {
    isEditingName,
    newName,
    renamingFile,
    editingRef,
    handleEditName,
    handleNameChange,
    handleKeyDown,
    handleRename,
  } = useRenameFile({
    item: {
      id: node.id,
      name: node.name,
      type: 'folder',
      createdAt: node.created_at,
      size: node.size,
      creationId: node.id,
      parentId: node.parent_id,
      last_open_at: node.last_open_at,
      depth: node.depth,
    },
    onFilesUpdate,
    onSuccess: (newName) => {
      // 重命名完成，传递新名称
      onRenameStateChange('completed', {
        nodeId: node.id,
        newName,
      });
    },
  });

  if (isEditingName) {
    return (
      <div ref={editingRef} className="flex-1">
        <Input
          autoFocus
          className="h-[30px] w-fit rounded-4 border border-[#343434] bg-[#20232A] px-4 text-system-white"
          value={newName}
          disabled={renamingFile}
          onChange={(e) => handleNameChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleRename}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>
    );
  }

  return (
    <span
      className="flex-1 cursor-pointer select-none truncate text-sm"
      onDoubleClick={() => {
        if (!isEditingName) {
          handleEditName();
          onRenameStateChange('renaming', { nodeId: node.id });
        }
      }}
    >
      {node.name}
    </span>
  );
};
